import React from 'react';

export const GoogleTagManager = () => (
	<noscript>
		<iframe
			title='Google Tag Manager'
			src='https://www.googletagmanager.com/ns.html?id=GTM-8CXX'
			height='0'
			width='0'
			style={{ display: 'none', visibility: 'hidden' }}
		/>
	</noscript>
);
